import React from 'react';
export function Footer() {
  return <footer className="border-t border-line bg-panel py-6" data-id="element-60" data-mp="32wd2qgad7ltj">
      <div className="mx-auto max-w-[1080px] px-4 sm:px-6" data-id="element-61" data-mp="3gfivmltl4hfp">
        <p className="text-[11.5px] font-medium leading-snug text-metal sm:text-[13px]" data-id="element-62" data-mp="3gh3rcermy6f5">
          © 2026 MOTORCYCLE DIAGNOSTIC PRO™ — All Rights Reserved. MOTORCYCLE
          DIAGNOSTIC PRO™ is a professional diagnostic reference and
          troubleshooting resource. It does not replace manufacturer service
          information, required technical training, workshop safety procedures or
          qualified professional judgment.
        </p>
        <p className="mt-2 text-[11.5px] font-semibold uppercase tracking-wide text-metal sm:text-[13px]" data-id="element-63" data-mp="3ldanjfu8c3jw">
          Terms &amp; Conditions • Privacy Policy • Contact Support:{' '}
          <a href="mailto:kitonline27@gmail.com" className="text-brandorange underline decoration-brandorange/50 underline-offset-2 transition-colors duration-150 ease-out hover:text-white" data-id="element-64" data-mp="29ynmjnzj5bfl">
            kitonline27@gmail.com
          </a>
        </p>
      </div>
    </footer>;
}